import moment from "moment";

export const allowedDatesFixedRate = (val, currentLoan) => {
  const start = moment(currentLoan.curRefRateIntStart);
  const type = currentLoan.refRateType;

  if (!start.isValid() || !type) return false;

  const intervalMonths = {
    "euribor 3": 3,
    "euribor 6": 6,
    "euribor 12": 12,
  }[type];

  if (!intervalMonths) return false;

  const selectedDate = moment(val).startOf("day");
  const maxYears = 50;

  for (let i = 1; i <= (maxYears * 12) / intervalMonths; i++) {
    const allowed = start.clone().add(i * intervalMonths, "months");

    // Tämä huomioi kuukaudet, joissa kyseistä päivää ei ole (esim. 31.2.)
    if (!allowed.isValid()) continue;

    if (selectedDate.isSame(allowed, "day")) {
      return true;
    }
  }

  return false;
};
